<template>
  <main id="itemList" v-cloak>
    <div class="container">
      <div class="row">
        <!-- Sidebar-->
        <category-filter
          :categories="categories"
          v-model="filter"
        ></category-filter>
        <!-- /Sidebar end-->
        <!-- Grid -->
        <div class="products-grid col-xl-9 col-lg-8 sidebar-left">
          <item-count
            :count="filteredItems.length"
            :total="items.length"
            v-model="itemsPerPage"
          ></item-count>
          <div class="row">
            <!-- item-->
            <div
              class="item col-xl-3 col-md-6 col-6"
              v-for="item in filteredItems"
              :key="item.id"
            >
              <slot :item="item"></slot>
            </div>
          </div>
          <show-more-button v-model="itemsPerPage"></show-more-button>
          <item-count
            :count="filteredItems.length"
            :total="items.length"
            v-model="itemsPerPage"
          ></item-count>
        </div>
        <!-- / Grid End-->
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import CategoryFilter from './CategoryFilter.vue';
import ItemCount from './ItemCount.vue';
import ShowMoreButton from './ShowMoreButton.vue';
import type Category from '../common/Category';
import type { CatalogItem } from '../common/CatalogItem';
import { every, filter, intersection, isEmpty, some, take } from 'lodash-es';

export default defineComponent({
  name: 'ItemList',
  components: {
    'category-filter': CategoryFilter,
    'item-count': ItemCount,
    'show-more-button': ShowMoreButton,
  },
  props: {
    categories: Array as PropType<Category[]>,
    items: Array as PropType<CatalogItem[]>,
    filterMode: String,
  },
  data() {
    const urlParams = new URLSearchParams(window.location.search);
    const filter = JSON.parse(urlParams.get('filter') || '{}');
    const itemsPerPage = Number(urlParams.get('itemsPerPage')) || 24;
    return {
      filterData: filter as Record<string, string[]>,
      itemsPerPageData: itemsPerPage as number,
    };
  },
  computed: {
    filter: {
      get() {
        return this.filterData;
      },
      set(newValue: Record<string, string[]>) {
        this.filterData = newValue;
        const url = new URL(window.location.toString());
        url.searchParams.set('filter', JSON.stringify(newValue));
        history.replaceState({}, '', url.toString());
      },
    },
    itemsPerPage: {
      get() {
        return this.itemsPerPageData;
      },
      set(newValue: number) {
        this.itemsPerPageData = newValue;
        const url = new URL(window.location.toString());
        url.searchParams.set('itemsPerPage', newValue.toString());
        history.replaceState({}, '', url.toString());
      },
    },
    filteredItems(): CatalogItem[] {
      const modeFn = this.filterMode === 'and-or' ? every : some;
      if (isEmpty(this.filter)) {
        return take(this.items, this.itemsPerPage);
      }
      const nonEmptyCategories = filter(this.filter, function (category) {
        return category.length > 0;
      });
      //console.log(nonEmptyCategories);
      if (nonEmptyCategories.length === 0) {
        return take(this.items, this.itemsPerPage);
      }
      return take(
        filter(this.items, function (item) {
          return modeFn(nonEmptyCategories, function (selectedChildren) {
            if (selectedChildren.length === 0) return true;
            return intersection(item.categories, selectedChildren).length > 0;
          });
        }),
        this.itemsPerPage,
      );
    },
  },
});
</script>

<style scoped></style>
